import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import { fetchApi } from "../../utlis/axios";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { FiRefreshCcw } from "react-icons/fi";

const FamilyExpenseChart = () => {
  const { access } = useSelector((state) => state.authSlice.userInfo);
  const [donation, setDonation] = useState({
    education: 0,
    food: 0,
    health: 0,
    bussiness: 0,
    others: 0,
  });
  const [refreshing, setRefreshing] = useState(false);

  const getDonationStatus = async () => {
    try {
      const result = await fetchApi.get("/donation-graph", {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });
      if (result.status === 200) {
        const apiData = result.data;

        // Calculate the count for each status
        const statusCounts = apiData.reduce((counts, item) => {
          counts[item.type] = (counts[item.type] || 0) + 1;
          return counts;
        }, {});

        setDonation({
          education: statusCounts.education || 0,
          food: statusCounts.food || 0,
          health: statusCounts.health || 0,
          bussiness: statusCounts.bussiness || 0,
          others: statusCounts.others || 0,
        });
      }
    } catch (error) {
      console.log({ error });
    }
  };

  useEffect(() => {
    getDonationStatus();
  }, []);

  async function handleRefresh() {
    setRefreshing(true);
    await getDonationStatus();
    setRefreshing(false);
  }

  const data = {
    labels: ["Education", "Health", "Food", "Business", "Others"],
    datasets: [
      {
        label: "Expense Chart",
        data: [
          donation.education,
          donation.health,
          donation.food,
          donation.bussiness,
          donation.others,
        ],
        backgroundColor: "#ffbe70",
      },
    ],
  };

  const options = {
    scales: {
      x: {
        type: "category",
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 15,
          usePointStyle: false,
          boxHeight: 15,
          padding: 10,
          color: "#000",
          font: {
            size: 15,
            weight: "700",
            family: "'Plus Jakarta Sans', sans-serif",
          },
        },
      },
    },
  };

  return (
    <div className="dashboardCard w-full h-full bg-white shadow rounded-xl sm:p-5 p-2.5">
      <div className="flex justify-between items-center">
        <p style={{ color: "black", fontSize: "20px" }}>Family Revenue</p>
        <span
          onClick={handleRefresh}
          disabled={refreshing}
          className={`p-2 w-max rounded-lg cursor-pointer !border-[2px] !border-[#D8D8D8] hover:bg-gray-50 transition bg-transparent shadow-none `}
        >
          <FiRefreshCcw
            className={`text-gray-600 text-lg ${
              refreshing ? "animate-spin" : ""
            }`}
          />
        </span>
      </div>
      <Link to="/donationdetailpage" className="">
        <div
          className="expense-chart dashboard-responsive"
          style={{ height: "-webkit-fill-available" }}
        >
          <Bar data={data} options={options} height={280} />
        </div>
      </Link>
    </div>
  );
};

export default FamilyExpenseChart;
